var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    borders = _ref.borders,
    typography = _ref.typography;
  return {
    entryDetailPadding: spacing.small,
    headerRowColor: colors.ash,
    buttonsZIndex: '3333',
    expandButtonContainerBorderWidth: borders.widthMedium,
    expandButtonContainerBorderColor: colors.tiara,
    addButtonMargin: spacing.small,
    headerTextColor: colors.ash,
    headerTextFontSize: typography.fontSizeXSmall,
    stemFontSize: typography.fontSizeMedium,
    stemLineHeight: typography.lineHeight,
    footerPadding: spacing.medium,
    footerBorderWidth: borders.widthSmall,
    footerBorderColor: colors.tiara,
    footerFontSize: typography.fontSizeXSmall,
    deletePrefaceMargin: spacing.xxSmall
  };
};
export default generateComponentTheme;